import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment-timezone';
import { sessionCheck } from 'src/actions/user';
import { showDialog } from 'src/actions/dialog';
import { NameDialog } from "src/components/shared";
import { getCurrentCollection, getPresetsDropdown, deleteCurrentCollection } from 'src/actions/prioritize';
import Prioritize from '../'
import { DEFAULT_CUSTOM_ATTR_VALUE, LABELS, DEFAULT_SUB_COLLECTIONS } from 'src/util/PrioritizeUtil'
import collectionApi from 'src/api/v2/CollectionApi'
import Logger from 'src/util/Logger';
import './Create.scss';
import { GLOBAL_PATH_PREFIX } from 'src/constants';

class Create extends Component {

  constructor(props) {
    super(props);

    this.state = {
      id: null,
      step: 1,
      selectedPreset: {},
      title: '',
      items: props.collection && props.collection.children
        ? props.collection.children
        : DEFAULT_SUB_COLLECTIONS.children,
      endDatetime: props.collection && props.collection.end_on
        ? moment(props.collection.end_on)
        : moment(moment()).add(3, 'days'),
      customAttr1: DEFAULT_CUSTOM_ATTR_VALUE,
      titleWarning: false,
      isNameDialogOpen: false,
    };

    this.onStateChange = this.onStateChange.bind(this)
    this.isStepOneComplete = this.isStepOneComplete.bind(this)
  }

  onStateChange = (field, value) => {
    if (this.isStepOneComplete()) {
      this.setState({ titleWarning: false })
    }
    this.setState({
      [field]: value
    })
  }

  onNext = (event) => {
    const { location, history } = this.props;

    if (!this.isStepOneComplete()) {
      this.setState({ titleWarning: true })
      return
    }
    if (location.pathname.match(/p\/.*\/edit/)) {
      history.push(`${location.pathname}/factors`)
    }
    this.setState({
      step: 2
    });
    if (this.props.collection.id) {
      this.saveUpdate();
    } else {
      this.saveCreate().then(newCollectionId => {
        history.push(`${GLOBAL_PATH_PREFIX}/p/${newCollectionId}/edit/factors`)
      });
    }
  }

  onSaveNPreview = () => {
    Logger.info('Save & Preview clicked');
    const participateURI = `${GLOBAL_PATH_PREFIX}/p/${this.props.collection.id}`;
    // TODO: Need to figure out why history push is not showing the most current collection data
    this.props.history.push(participateURI);

    // TODO: Need to replace this with history push above once the state sync situation is sorted out
    // ensure the participate page is refreshed
    // window.location.href = participateURI;
  };

  onBack = () => {
    const { location, history } = this.props;
    if (location.pathname.match(/p\/.*\/edit\/factors/)) {
      this.setState({ step: this.state.step - 1 })
      const editUrl = location.pathname.split('/')
      editUrl.pop()
      history.push(`${editUrl.join('/')}`)
    } else {
      window.location.href = '/#/dashboard';
    }
  }


  isStepOneComplete = () => {
    const { title, subCollections } = this.state
    return !_.isEmpty(title) && subCollections.filter((obj) => obj.title).length > 0;
  }

  saveCreate = async () => {
    const { title, selectedPreset, endDatetime, customAttr1, subCollections } = this.state
    const payload = {
      title: title,
      collection_type: 'prioritize',
      collection_sub_type: selectedPreset.collection_sub_type,
      end_on: endDatetime,
      timezone: moment.tz.guess(),
      custom_attr_1: customAttr1
    }
    try {
      const children = subCollections
        .filter(item => item.title)
        .map(item => ({ title: item.title, description: item.description, collection_type: 'prioritize-item', custom_attr_1: item.custom_attr_1 }));

      const rootCollection = await collectionApi.create(payload)
      this.setState({ id: rootCollection.id });

      // Create children
      const newChildren = await collectionApi.createChildren(rootCollection.id, children)
      rootCollection.children = newChildren;

      // Create questions using selected category
      const selectedPresetCollection = await collectionApi.get({ id: selectedPreset.id })
      await collectionApi.createQuestions(rootCollection.id, selectedPresetCollection.questions)

      // Reload details with all newly created children and questions
      const collectionDetails = await collectionApi.get({ id: rootCollection.id })
      this.props.getCurrentCollection(collectionDetails);

      return rootCollection.id;
    } catch (error) {
      console.log(error);
    }
  };

  saveUpdate = async () => {
    const { title, selectedPreset, endDatetime, customAttr1 } = this.state
    const payload = {
      id: this.props.collection.id,
      title: title,
      collection_type: 'prioritize',
      collection_sub_type: selectedPreset.collection_sub_type,
      end_on: endDatetime,
      timezone: moment.tz.guess(),
      custom_attr_1: customAttr1
    }

    await collectionApi.update(payload);
    const updatedDetails = await collectionApi.get({ id: this.props.collection.id })
    this.props.getCurrentCollection(updatedDetails);
  };

  dropdownItemTypes = (itemTypes) => itemTypes.map(({ label, value }) => ({ id: value, text: label }))

  onButtonClick = (buttonType) => () => {
    const { subCollections } = this.state

    switch (buttonType) {
      case 'back':
        this.onBack()
        break;
      case 'next':
        this.onNext()
        break;
      case 'add':
        this.onStateChange('subCollections', [...subCollections, { title: '', custom_attr_1: '' }])
        break;
      case 'save_preset':
        this.setState({ isNewPresetModalOpen: true })
        break;
      case 'submit':
        this.onSaveNPreview()
        break;

      default:
        break;
    }
  }

  render() {
    const { children, step, onNavClick, disabledButtons } = this.props;
    const title = LABELS.create_steps_title[step - 1];

    return (
      <Prioritize
        title={title}
        redText={`Step ${step} of 2`}
        step={step}
        headerNav={true}
        onNavClick={onNavClick}
        disabledButtons={disabledButtons}
      >
        <div className='create__progress' style={{ width: `${step * 50}%` }}></div>
        {children}
        <NameDialog
          isOpen={this.state.isNameDialogOpen}
          // onSaveName={() => setNameDialogOpen(false)}
        />
      </Prioritize>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    userError: state.user.error,
    presets: state.prioritize.presets,
    collection: state.prioritize.collection
  };
};

export default withRouter(connect(mapStateToProps, {
  sessionCheck,
  showDialog,
  getCurrentCollection,
  getPresetsDropdown,
  deleteCurrentCollection
})(Create));
